// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"ListTemplate_menuBar__12PVU"};